import sortBy from 'lodash.sortby';
import {DateTime} from 'luxon';
import i18n from "../../../service/locale/i18";

export default class MessagesHelper {
    // messages = [];

    prepareMessages(messages, locale = 'en', format = 'dd MMMM', needToday = true) {
        const list = this._getList(messages);
        const groupedList = {};

        let currentDate = null,
            currentTime = null,
            currentUserId = null,
            currentType =  null,
            today = DateTime.local().setLocale(locale).toFormat(format);

        list.forEach((item) => {
            let date = this._getDate(item, format, locale);
            const timeDiff = currentTime ? item.createdAt.diff(currentTime, 'seconds').seconds : 0;

            if (today == date && needToday) {
                date = i18n.t('common.today');
            }
            currentTime = item.createdAt;

            if (!groupedList[date]) {
                groupedList[date] = [];
            }
            const sameGroup = currentDate === date && item.userID == currentUserId && timeDiff <= 5 && item.type == currentType;
            if (!sameGroup) {
                groupedList[date].push([]);
            }

            currentDate = date;
            currentUserId = item.userID;
            currentType = item.type;
            groupedList[date][groupedList[date].length - 1].push(item);
        });
        return groupedList;
    }

    _getList(messages) {
        return sortBy(messages, (item) => item.createdAt);
    }

    _getDate(message, format, locale) {
        return message.createdAt.setLocale(locale).toFormat(format);
    }
}